/* Calena — cart "Goes well with" add-on (2026-10-19).
   The add-on markup (snippets/calena-cart-addon.liquid) is re-rendered whenever the cart changes,
   so this file uses one delegated click listener plus an observer that prepares new add-on boxes. */
(() => {
  if (window.__ccCartAddon) return;
  window.__ccCartAddon = true;

  // Size-matched add-ons (e.g. a pillow protector for a pillow): keep only sizes near the cart item's size.
  const dims = (t) => {
    const m = (t || '').match(/(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*in/i);
    return m ? [+m[1], +m[2]].sort((a, b) => a - b) : null;
  };
  const near = (a, b) => a && b && Math.abs(a[0] - b[0]) <= 1.5 && Math.abs(a[1] - b[1]) <= 1.5;

  const prepare = (box) => {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    const select = box.querySelector('select[data-cc-variant]');
    const price = box.querySelector('[data-cc-price]');
    if (!select) return;
    const want = dims(box.dataset.forTitle);
    if (want) {
      const keep = [];
      [...select.options].forEach((o) => {
        const d = dims(o.text);
        // keep sizes that fit the cart item, and drop near-duplicates (e.g. 51 × 66 cm vs 50 × 66 cm)
        if (near(d, want) && !keep.some((k) => near(dims(k.text), d) && Math.abs(dims(k.text)[0] - d[0]) + Math.abs(dims(k.text)[1] - d[1]) < 1.5)) keep.push(o);
      });
      if (keep.length) {
        [...select.options].forEach((o) => { if (!keep.includes(o)) o.remove(); });
        select.value = keep[0].value;
      }
    }
    const sync = () => { const o = select.options[select.selectedIndex]; if (o && o.dataset.price) price.textContent = o.dataset.price; };
    sync();
    if (select.options.length < 2) select.hidden = true;
    select.addEventListener('change', sync);
  };

  const scan = () => document.querySelectorAll('[data-cc-cart-addon]:not([data-ready])').forEach(prepare);
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('[data-cc-cart-addon-add]');
    if (!btn) return;
    e.preventDefault();
    const box = btn.closest('[data-cc-cart-addon]');
    const id = Number(box.querySelector('[data-cc-variant]').value);
    const note = box.querySelector('[data-cc-note]');
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'calena-cart-addon', data: { source: 'calena-cart-addon', itemCount: cart.item_count } }
      }));
      // The cart page does not listen for cart:update the way the drawer does — reload it so totals stay right.
      if (location.pathname.replace(/\/$/, '').endsWith('/cart')) location.reload();
    } catch (err) {
      btn.disabled = false;
      if (note) { note.textContent = 'Couldn’t add it right now — you can add it from its own page.'; note.hidden = false; }
    }
  });
})();
